<template>
  <b-modal scrollable no-fade hide-footer ref="modal" id="page-modal" size="xl" @hide="onHide()">
    <TourMessage v-if="!account[1] && !isDuda" id="details" :account="account[0]" />
    <PageSimple
      v-if="$route.params.page_id && account.length"
      ref="page"
      :page="page"
      :site="site"
      :site_delta="site_delta"
      :account="account"
      :crawling="crawling"
      :isDuda="isDuda"
      @refresh="refresh()"
      @crawl="crawlPage($route.params.page_id)"
      @status="setPageStatus(page, $event)"
    />
    <template #modal-title>
      <b-skeleton-wrapper :loading="!page.id || $apollo.queries.page.loading">
        <template #loading>
          <b-skeleton width="30rem" />
        </template>
        <span v-if="page.status == 'completed'">Monitoring</span>
        <span v-else>Optimizations for</span>
        <a 
          :href="page.url"
          :title="page.url"
          target="_blank"
          class="text-break ml-2"
        >
          <span class="page_url">{{decodeURI(page.url_normalized) | truncate(80)}}</span>
          <b-icon-box-arrow-up-right class="ml-1"/>
        </a>
      </b-skeleton-wrapper>
    </template>
  </b-modal>
</template>
<style>
#page-modal .modal-dialog {
  max-width: min(1140px, 95%);
}
#page-modal .modal-body {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
<script>
import TourMessage from '@/components/TourMessage.vue'
import PageSimple from '@/views/site/PageSimple'
import PagesTable from '@/components/PagesTable'
import PAGE_QUERY from '@/graphql/PageQuery.gql'
import CRAWL_PAGE_MUTATION from '@/graphql/CrawlPage.gql'
import PAGE_MUTATE from '@/graphql/PageMutate.gql'
import {get} from 'lodash'

export default {
  name: 'PageModal',
  components: { TourMessage, PageSimple },
  props: ['site', 'account', 'isProcessing', 'site_delta', 'isFreetrial', 'isDuda'],

  data() {
    return {
      page: {inbound_links: []},
      crawling: false,
      statuses: {
        ignored: 'Ignored',
        not_started: 'Not Yet Started',
        in_progress: 'In Progress',
        completed: 'Monitoring',
        archived: 'Archived',
      },
    }
  },

  apollo: {
    page: {
      query: PAGE_QUERY,
      variables() {
        return {
          id: this.$route.params.page_id,
          withQueries: true,
          withLinks: true,
        }
      },
      skip() {
        return !this.$route.params.page_id
      },
    },
  },

  watch: {
    isProcessing(to) {
      if(to) {
        this.$apollo.queries.page.startPolling(3000)
      } else {
        const $vm = this
        setTimeout(() => {
          $vm.$apollo.queries.page.stopPolling()
          $vm.$apollo.queries.page.refetch()
          $vm.$refs.modal.$emit('refresh')
          $vm.crawling = false
        }, 3000)
      }
    },
    '$route.params.page_id': {
      immediate: true,
      async handler(to) {
        if(!this.$refs.modal) {
          await this.$nextTick()
        }
        if(to) {
          this.$refs.modal.show()
        } else {
          this.$refs.modal.hide()
        }
      }
    },
    isObscured(to) {
      if(to) {
        this.$refs.modal.hide()
      }
    },
    'page.id'() {
      if(this.isObscured) {
        this.$refs.modal.hide()
      }
    }
  },

  computed: {
    label() {
      return get(this.page, 'top_query[0].query')
    },
    isObscured() {
      return PagesTable.methods.isObscured(this.page, this.isFreetrial)
    },
    pageStatus() {
      return this.statuses[this.page.status || this.page.status_inferred]
    },
  },

  methods: {
    show() {
      this.$refs.modal.show()
    },
    onHide() {
      this.$router.push({params: {page_id: undefined}, query: this.$route.query})
    },
    async refresh() {
      try {
        await this.$apollo.queries.page.refetch()
        this.$emit('refresh')
      } catch {}
    },
    async setPageStatus(page, status) {
      if(page.status_inferred == status) {
        status = null
      }
      await this.$apollo.mutate({
        mutation: PAGE_MUTATE,
        variables: {
          id: page.id,
          changes: {status}
        }
      })
      _zyppy.track('Page Status Changed', {
        status: status,
        page_id: page.id,
        site_id: page.site_id,
      })
      if(!['archived', 'ignored'].includes(status)) {
        this.crawlPage(page.id, false)
      }
    },
    async crawlPage(page_id, track = true) {
      try {
        this.crawling = true
        await this.$apollo.mutate({
          mutation: CRAWL_PAGE_MUTATION,
          variables: {
            page_id
          }
        })
        if(track && this.$route.params.page_id == page_id) {
          _zyppy.track('Page Recrawled', {page_id})
        }
        // Sometimes crawl is completed before isProcessing is toggled
        const $vm = this
        setTimeout(() => {
          if(!$vm.isProcessing) {
            $vm.$apollo.queries.page.refetch()
            $vm.$refs.modal.$emit('refresh')
            $vm.crawling = false
          }
        }, 6000)
      } catch(error) {
        this.crawling = false
        throw error
      }
    },
  }
}
</script>